import React from "react";
import { useNavigate } from "react-router-dom";
import StyledButton from "@/components/StyledHtmlElements/Button";
import Box from "@/components/StyledHtmlElements/Box";

const Impressum: React.FC = () => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <main className="flex justify-center items-center h-[100vh]">
      <Box className="text-xs md:text-lg bg-white w-full max-w-md text-center">
        <h2 className="text-sm md:text-2xl font-bold mb-6">Impressum</h2>
        <p>Icehawkai UG (haftungsbeschränkt) i.G</p>
        <p>Carsten Pauli</p>
        <p>Bagelstraße 107, 40479 Düsseldorf</p>
        <p>pauli@icehawkai.de</p>
        <p>+49 (0)211 97179205</p>
        <StyledButton
          onClick={handleBack}
          className="text-xs md:text-lg w-full mt-6">
          Back
        </StyledButton>
      </Box>
    </main>
  );
};

export default Impressum;
